import React from "react";
import { Oval } from "react-loader-spinner";

function Posting() {
  const [orderNo, setOrderNo] = React.useState("");
  const [buyer, setBuyer] = React.useState("");
  const [seller, setSeller] = React.useState("");
  const [rate, setRate] = React.useState("");
  const [status, setStatus] = React.useState("");
  const [price, setPrice] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // 'yyyy-mm-dd'
  };

  const [soldDate, setSoldDate] = React.useState(getTodayDate());

  const handlePost = (e) => {
    e.preventDefault();
  };

  return (
    <div>
      <h1>Posting</h1>
      <form onSubmit={handlePost}>
        <h1 className="mb-3 font-bold text-lg">Phones</h1>
        <div className="grid grid-cols-3 gap-4 max-w-3xl mx-auto">
          <div className="relative w-full">
            <label
              htmlFor="model"
              className="absolute left-3 bg-white px-2 font text-gray-400"
              style={{ top: "-12px" }}
            >
              Order No
            </label>
            <input
              className="border p-2 w-full rounded"
              id="OrderNo"
              type="text"
              placeholder="Order No"
              value={orderNo}
              onChange={(e) => setOrderNo(e.target.value)}
            />
          </div>

          <div className="relative w-full">
            <label
              htmlFor="price"
              className="absolute left-3 bg-white px-2 font text-gray-400"
              style={{ top: "-12px" }}
            >
              Price
            </label>
            <input
              className="border p-2 w-full rounded"
              id="price"
              type="text"
              placeholder="900"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
          </div>
          <div className="relative w-full">
            <label
              htmlFor="price"
              className="absolute left-3 bg-white px-2 font text-gray-400"
              style={{ top: "-12px" }}
            >
              Rate
            </label>
            <input
              className="border p-2 w-full rounded"
              id="rate"
              type="text"
              placeholder="22.5"
              value={rate}
              onChange={(e) => setRate(e.target.value)}
            />
          </div>
          <div className="relative w-full">
            <label
              htmlFor="price"
              className="absolute left-3 bg-white px-2 font text-gray-400"
              style={{ top: "-12px" }}
            >
              Buyer
            </label>
            <input
              className="border p-2 w-full rounded"
              id="buyer"
              type="text"
              placeholder="Name"
              value={buyer}
              onChange={(e) => setBuyer(e.target.value)}
            />
          </div>
          <div className="relative w-full">
            <label
              htmlFor="status"
              className="absolute left-3 bg-white px-2 font text-gray-400"
              style={{ top: "-12px" }}
            >
              Status
            </label>
            <select
              name="status"
              id="status"
              className="border mb-4 p-2 w-full rounded"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="" disabled>
                Status
              </option>
              <option value="Ordered">Ordered</option>
              <option value="Received">Received</option>
              <option value="Sent">Sent</option>
              <option value="Return Received">Return Received</option>
              <option value="Return Sent">Return Sent</option>
            </select>
          </div>
          <div className="relative w-full">
            <label
              htmlFor="status"
              className="absolute left-3 bg-white px-2 font text-gray-400"
              style={{ top: "-12px" }}
            >
              Seller
            </label>
            <select
              name="seller"
              id="seller"
              className="border mb-4 p-2 w-full rounded"
              value={seller}
              onChange={(e) => setSeller(e.target.value)}
            >
              <option value="" disabled>
                Seller
              </option>
              <option value="Mihret">Mihret</option>
              <option value="Natnael">Natnael</option>
              <option value="Yeabkal">Yeabkal</option>
              <option value="Yeabtsega">Yeabtsega</option>
            </select>
          </div>
          <div className="relative w-full">
            <label
              htmlFor="soldDate"
              className="absolute left-3 bg-white px-2 text-sm text-gray-400"
              style={{ top: "-12px" }}
            >
              Sold Date
            </label>
            <input
              className="border p-2 w-full rounded"
              id="soldDate"
              type="date"
              value={soldDate}
              onChange={(e) => setSoldDate(e.target.value)}
            />
          </div>
          </div>
          <div className="mx-auto mt-4 max-w">

          {loading ? (
            <button className="bg-slate-600 hover:bg-slate-500 text-white font-bold py-2 px-4 mt-2 rounded">
              <Oval
                height={20}
                width={20}
                color="#fff"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                ariaLabel="oval-loading"
                secondaryColor="#4fa94d"
                strokeWidth={2}
                strokeWidthSecondary={2}
              />
            </button>
          ) : (
            <button
              className="bg-slate-600 hover:bg-slate-500 text-white font-bold py-2 px-4 mt-2 rounded"
              type="submit"
            >
              Add
            </button>
          )}
        </div>
      </form>

      <div>
        <table className="w-full border-collapse max-w-4xl mx-auto mt-8">
          <thead className="sticky top-0">
            <tr>
              <th className="sticky top-0 z-10 border-b border-slate-600 text-left  bg-gray-200">
                Order No
              </th>
              <th className="sticky top-0 z-10 border-b border-slate-600 text-left  bg-gray-200">
                Price
              </th>
              <th className="sticky top-0 z-10 border-b border-slate-600 text-left  bg-gray-200">
                Rate
              </th>
              <th className="sticky top-0 z-10 border-b border-slate-600 text-left  bg-gray-200">
                Buyer
              </th>
              <th className="sticky top-0 z-10 border-b border-slate-600 text-left  bg-gray-200">
                Status
              </th>
              <th className="sticky top-0 z-10 border-b border-slate-600 text-left  bg-gray-200">
                Seller
              </th>
              <th className="sticky top-0 z-10 border-b border-slate-600 text-left  bg-gray-200">
                Sold Date
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                cfg
              </td>
              <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                cfg
              </td>
              <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                cfg
              </td>
              <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                cfg
              </td>
              <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                cfg
              </td>
              <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                cfg
              </td>
              <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                cfg
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Posting;
